import React from "react";
import Select from "react-select";

import CargadorVersiones from "../../_helpers/CargadorVersiones";
class FiltrosDashboard extends React.Component {
    constructor(props) {
        super(props);
    }

    buscarMisModelos = (modelos, marcaId) => {
        let finalModelos = [];

        if (marcaId === undefined) {
            return finalModelos;
        }

        finalModelos = modelos?.filter((it) => it.marca.id === marcaId);

        return finalModelos;
    };

    buscarMisVersiones = (versiones, modeloId) => {
        let finalVersiones = [];

        if (modeloId === undefined) {
            return finalVersiones;
        }

        finalVersiones = versiones?.filter((it) => it.modelo.id === modeloId);

        return finalVersiones;
    };

    render() {
        const {submitForm, setFieldValue, filtros, values, forPublicacion, forVenta} = this.props;
        /*
         * react-select trae 38px de alto minimo y bastante aire adentro del control.
         * Cuatro de estos apilados en mobile eran mas altos que la tabla que
         * filtran, asi que se bajan a 32 — `minHeight` ademas de `height`, porque
         * el minimo por defecto le gana a un `height` suelto.
         */
        const customSelect = {
            control: (provided) => ({ // class attribute : class=" css-i32vvf-control"
                ...provided,
                background: 'transparent',
                borderColor: 'transparent',
                minHeight: '32px',
                height: '32px',
            }),
            valueContainer: (provided) => ({...provided, padding: '0 0.4rem'}),
            dropdownIndicator: (provided) => ({...provided, padding: '0 0.25rem'}),
            clearIndicator: (provided) => ({...provided, padding: '0 0.25rem'}),
            menuPortal: base => ({...base, zIndex: 9999})
        };

        return (
            <>

                <div className="filterby_container">
                    {/*
                        En mobile se esconde por CSS: los placeholders de cada select
                        ("Tipo", "Marca", ...) ya dicen lo mismo y el rotulo se
                        llevaba un renglon entero.
                    */}
                    <span className="filterby_label">Filtrar por: </span>

                    {/* {forPublicacion === true &&
								<Select
									className="filter_select"
									cacheOptions
									defaultOptions
									isClearable={true}
									value={
										filtros?.estadosPublicacion
											? filtros?.estadosPublicacion.find(
												(option) => option.nombre === values.estado
											)
											: ""
									}
									placeholder="Estado"
									getOptionLabel={(option) => `${option.nombre}`}
									getOptionValue={(option) => option.id}
									options={filtros?.estadosPublicacion}
									onChange={(opt) => {
										setFieldValue("estado", opt.nombre);
										submitForm();
									}}
									components={{
										IndicatorSeparator: () => null
									}}
									styles={customSelect}
								/>
							} */}

                    {/* {forVenta === true &&
								<Select
									className="filter_select"
									cacheOptions
									defaultOptions
									isClearable={true}
									value={
										filtros?.estadosVenta
											? filtros?.estadosVenta.find(
												(option) => option.nombre === values.estado
											)
											: ""
									}
									placeholder="Estado"
									getOptionLabel={(option) => `${option.nombre}`}
									getOptionValue={(option) => option.id}
									options={filtros?.estadosVenta}
									onChange={(opt) => {
										setFieldValue("estado", opt.nombre);
										submitForm();

									}}
									components={{
										IndicatorSeparator: () => null
									}}
									styles={customSelect}
								/>
							} */}

                    <Select
                        className="filter_select"
                        cacheOptions
                        defaultOptions
                        isClearable={true}
                        value={
                            filtros?.tipoRepuestos
                                ? filtros?.tipoRepuestos.find(
                                    (option) => option.id === values.tipoRepuesto?.id
                                )
                                : ""
                        }
                        placeholder="Tipo"
                        getOptionLabel={(option) => `${option.nombre}`}
                        getOptionValue={(option) => option.id}
                        options={filtros?.tipoRepuestos}
                        onChange={(opt) => {
                            setFieldValue("tipoRepuesto", opt);
                            submitForm();

                        }}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />

                    {/* <Form.Label>Marca</Form.Label> */}
                    <Select
                        className="filter_select"
                        cacheOptions
                        defaultOptions
                        isClearable={true}
                        value={
                            filtros?.marcas
                                ? filtros?.marcas.find(
                                    (option) => option.id === values.marca?.id
                                )
                                : ""
                        }
                        placeholder="Marca"
                        getOptionLabel={(option) => `${option.nombre}`}
                        getOptionValue={(option) => option.id}
                        options={filtros?.marcas}
                        onChange={(opt) => {
                            setFieldValue("marca", opt);
                            submitForm();

                        }}
                        noOptionsMessage={({inputValue}) => !inputValue ? "" : "No se encontraron marcas"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />

                    {/* <Form.Label>Modelo</Form.Label> */}
                    <Select
                        className="filter_select"
                        cacheOptions
                        defaultOptions
                        disabled={values.marca === undefined}
                        value={
                            filtros?.modelos
                                ? filtros?.modelos.find(
                                    (option) => option.id === values.modelo?.id
                                )
                                : ""
                        }
                        placeholder="Modelo"
                        isClearable={true}
                        getOptionLabel={(option) => `${option.nombre}`}
                        getOptionValue={(option) => option.id}
                        options={this.buscarMisModelos(filtros?.modelos, values.marca?.id)}
                        onChange={(opt) => {
                            setFieldValue("modelo", opt);
                            submitForm();

                        }}
                        noOptionsMessage={({inputValue}) => !inputValue ? "Elija una marca" : "No se encontraron modelos"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />

                    {/*
                        Los nombres de version son los mas largos ("1.5 Sedan Platinum
                        AT"), asi que este select va mas ancho en desktop. Antes eso
                        era un div envolvente con `style={{'min-width': '400px'}}`, que
                        React ignora — espera `minWidth` en camelCase — y encima
                        rompia la grilla de dos columnas de mobile. Ahora es una clase.
                    */}
                    <CargadorVersiones modeloId={values.modelo?.id}/>

                    <Select
                        className="filter_select filter_select--ancho"
                        cacheOptions

                        defaultOptions
                        isClearable={true}
                        disabled={values.modelo === undefined}
                        value={
                            filtros?.versiones
                                ? filtros?.versiones.find(
                                    (option) => option.id === values.version?.id
                                )
                                : ""
                        }
                        placeholder="Versión"
                        getOptionLabel={(option) => `${option.nombre}`}
                        getOptionValue={(option) => option.id}
                        options={this.buscarMisVersiones(
                            filtros?.versiones,
                            values.modelo?.id
                        )}
                        onChange={(opt) => {
                            setFieldValue("version", opt);
                            submitForm();

                        }}
                        noOptionsMessage={({inputValue}) => !inputValue ? "Elija un modelo" : "No se encontraron versiones"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />


                </div>

            </>
        );
    }
}

export default FiltrosDashboard;
